import type { QuestionViewProps } from "../contracts";
import { GridChoiceMatrix } from "../grid/GridChoiceMatrix";
import type {
  GridSelectDefinition,
  GridSelectDraft,
  GridSelectEvent,
} from "./core";

type GridSelectViewProps = QuestionViewProps<
  GridSelectDefinition,
  GridSelectDraft,
  GridSelectEvent
>;

const GridSelectView = (props: GridSelectViewProps) => {
  const options = props.definition.dontKnow
    ? [
        ...props.definition.options,
        {
          id: props.definition.dontKnow.value,
          label: props.definition.dontKnow.label,
          disabled: false,
          interactionDisabled: !props.controls.canSubmit,
        },
      ]
    : props.definition.options;
  return (
    <>
      <GridChoiceMatrix
        rows={props.definition.rows.map((row) => ({
          ...row,
          label: props.draft.specifiedRows?.[row.id] || row.label,
        }))}
        options={options}
        rowGroups={props.definition.rowGroups}
        optionGroups={props.definition.optionGroups}
        arrangement={props.display.arrangement}
        mode={props.display.view === "radio" ? "radio" : "button"}
        isSelected={(rowId, optionId) =>
          props.draft.selectedByRow[rowId]?.optionId === optionId
        }
        onSelect={(rowId, optionId) => {
          const option = props.definition.options.find(
            (item) => item.id === optionId,
          );
          if (option?.customPrompt !== undefined) {
            props.controls.specify?.open({
              kind: "option-answer",
              rowId,
              optionId: option.id,
            });
          } else props.dispatch({ type: "select", rowId, optionId });
        }}
        specify={props.controls.specify}
        testId="grid-select-view"
      />
    </>
  );
};

export const GridSelectButtonsView = GridSelectView;
export const GridSelectRadioView = GridSelectView;
